import styled from "styled-components";

export const SliderWrapper = styled.div`
    &.swiper-gallery {
        .swiper-wrapper {
            transition-timing-function: linear;
        }
    }
`;
